import {z} from 'zod';

import i18n from '@dms/i18n';

import {
  AccountingMatrixDatagridConfig,
  getAccountingMatrixDatagridSharedFields,
} from '../../utils/accountingMatrixDatagridConfig';

export const getAccountingMatrixDatagridM101CashConfig = (): AccountingMatrixDatagridConfig => ({
  dgCode: 'm101-cash',
  fields: [
    {
      name: 'account',
      label: i18n.t('page.accounting.labels.accountingMatrixDatagridsFieldAccount'),
      type: 'text',
      isRequired: true,
    },
    {
      name: 'name',
      label: i18n.t('general.labels.name'),
      type: 'text',
      isRequired: true,
    },
    {
      name: 'centre',
      label: i18n.t('page.accounting.labels.accountingMatrixDatagridsFieldCentre'),
      type: 'text',
      isRequired: true,
    },
    ...getAccountingMatrixDatagridSharedFields(),
  ],
  schema: z.object({
    account: z.string().min(1),
    name: z.string().min(1),
    centre: z.string().min(1),
    billingInformation: z.string().min(1),
    validFrom: z.string(),
    validTo: z.string(),
  }),
});
